import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from '@/router'

export function initAnalytics() {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_KEY,
    router,
    debug: {
      enabled: false,
      sendHitTask: process.env.NODE_ENV === 'production',
    },
  })
}
